import React, { useState } from 'react'
import { actionAtom } from 'atoms/atoms'
import { useSetAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box, Button, Highlight, Icon, toast } from '@node-space/ui-components'
import TwoFAModal from 'components/modals/TwoFAModal/TwoFAModal'
import { useMappedRoles } from 'hooks/useMappedRoles'
import { useTwoFAContext } from 'hooks/useTwoFAContext'
import { ActionIds } from 'types/types'
import { UserDetailsSheet } from './UserDetailsSheet'

export const Security = () => {
  const { t } = useTranslation()
  const [isChangePasswordSheetOpen, setIsChangePasswordSheetOpen] = useState(false)
  const setAction = useSetAtom(actionAtom)
  const { twoFactorEnabled, setShowTwoFAModal } = useTwoFAContext()
  const permissions = useMappedRoles()?.profile

  const canEdit = permissions?.canEdit

  const handleChangePassword = () => {
    setIsChangePasswordSheetOpen(true)
    setAction({
      actionId: ActionIds.CHANGE_PASSWORD,
      header: t('changePassword'),
      onClose: () => setIsChangePasswordSheetOpen(false),
    })
  }

  return (
    <Box flexCol gapY={20} align="start">
      <Box flex gapX={16} align="center">
        <h3 className="text-h3 text-foreground-prominent">{t('security')}</h3>
        {twoFactorEnabled && (
          <Highlight type="success" variant="emphasis" iconElement={<Icon name="Password" />}>
            {t('twoFactorAuthenticationEnabled')}
          </Highlight>
        )}
      </Box>

      <Box flex gapX={16}>
        {canEdit && (
          <Button
            variant="primary"
            data-testid="change-password-button"
            iconElement={<Icon name="SimplePencilCustom" />}
            onClick={handleChangePassword}
          >
            {t('changePassword')}
          </Button>
        )}

        {!twoFactorEnabled && canEdit && (
          <Button
            variant="primary"
            data-testid="enable-2FA-modal-button"
            onClick={() => setShowTwoFAModal(true)}
          >
            {t('twoFactorAuthentication')}
          </Button>
        )}
      </Box>

      <UserDetailsSheet isSheetOpen={isChangePasswordSheetOpen} />

      <TwoFAModal onComplete={() => toast({ header: t('2FASuccess'), variant: 'success' })} />
    </Box>
  )
}
